import { Pipe, PipeTransform } from '@angular/core';
import { ReferentielService } from "../services/referentiel.service";

@Pipe({
    name: 'referentiel',
    standalone: false
})
export class ReferentielPipe implements PipeTransform {

  constructor(private referentielService: ReferentielService) {

  }

  transform(value: any, referentiel: string): any {
    return this.referentielService.get(referentiel, value);
  }


}
